import { render } from "./ProfileAvatar.vue?vue&type=template&id=e502adee&scoped=true"
import script from "./ProfileAvatar.vue?vue&type=script&lang=js"
export * from "./ProfileAvatar.vue?vue&type=script&lang=js"

import "./ProfileAvatar.vue?vue&type=style&index=0&id=e502adee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e502adee"]])

export default __exports__